export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
}

export interface MessageImage {
  url: string;
  width?: number;
  height?: number;
}

export interface Message {
  id: string;
  sessionId: string;
  role: MessageRole;
  content: string;
  images?: MessageImage[];
  createdAt: string;
}

export interface Session {
  id: string;
  uid: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}

export interface SessionListItem {
  id: string;
  title: string | null;
  message_count: number;
  last_message: {
    content: string;
    role: "user" | "assistant";
    created_at: string;
  } | null;
  created_at: string;
  updated_at: string;
}

export interface AssistantState {
  sessions: Session[];
  currentSessionId: string | null;
  messages: Message[];
  isLoading: boolean;
  isLoadingMessages: boolean;
  isTyping: boolean;
  error: string | null;
}
